import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Avatar, Box, Card, CardContent } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import warning from '../../../assets/warning.png';
import green_warning from '../../../assets/green-warning.png';
import orange_warning from '../../../assets/orange-warning.png';
import yellow_warning from '../../../assets/yellow-warning.png';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: 10,
  },
  root: {
    width: '100%',
    margin: 2.5,
  }
}));

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const initialParameters = {
  uInf: 6,
  uSup: 30
};

export default function Plague({ plague }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [date, setDate] = React.useState(format(new Date(), 'yyyy-MM-dd'));
  const [parameters, setParameters] = React.useState(initialParameters);

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;

    setParameters({
      ...parameters,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleInputChange(event);
  };

  const diagnosis = (data) => {
    switch (data) {
      case "red":
        return warning;
        break;
      case "green":
        return green_warning;
        break;
      case "orange":
        return orange_warning;
        break;
      case "yellow":
        return yellow_warning;
        break;
    }
  }

  return (
    <Grid container
    spacing={2}
    alignItems="center"
    justifycontent="center"
    direction='row'
  >
      <Card className={classes.root} variant="outlined">
        <CardContent>
            {<h1 style={{ color: "dimGrey", margin: 0 }}>{plague.plague_parameter.plague.name}</h1>}

            <Grid container
              spacing={2}
              alignItems="center"
              justifycontent="center"
              direction='row'
            >

              {/* <Grid item xs='auto' style={{ margin: 15 }}>
                <InputForm inputValue={parameters.uInf} handleChange={handleInputChange} handleSubmit={handleSubmit} hText="Umbral Inferior" name="uInf" />
                <InputForm inputValue={parameters.uSup} handleChange={handleInputChange} handleSubmit={handleSubmit} hText="Umbral Superior" name="uSup" />
              </Grid> */}
  
              {[...Array(7),].map((key, index) => (
                <><Grid item xs='auto' alignItems="center" justifycontent="center">
                  <Box display="flex" flexDirection='column' justifyContent="center" alignItems="center" className={classes.root} p={1}>

                    <Avatar aria-label="recipe"
                      style={{ color: 'white', height: 'auto', width: '65px', margin: 5 }}
                      src={ diagnosis(plague.diagnosis[format(addDays(date, index), 'yyyy-MM-dd')]) }>
                    </Avatar>

                    {format(addDays(date, index), 'd MMM')}
                  </Box>
                  
                </Grid>
                </>)
              )}
            </Grid>
        </CardContent>
      </Card>
      </Grid>
  );
}